<template>
  <v-container id="data-tables" tag="section">
    <!-- <base-v-component heading="Data Tables" link="components/data-tables" /> -->

    <base-material-card color="blue" icon="mdi-account" inline class="px-5 py-3">
      <v-spacer></v-spacer>
      <template v-slot:after-heading> </template>
      <template v-slot:corner-button>
        <v-btn small class="ma-2" elevation="2" color="blue" @click.stop="dialog = true"
          >Nuevo Usuario</v-btn
        >
        <v-btn small class="ma-2" elevation="2" color="blue" @click.stop="dialog2 = true">
          <!-- <v-icon left x-small> mdi-email </v-icon> -->
          Invitar Usuario
        </v-btn>
      </template>

      <v-overlay :value="overlay">
        <v-progress-circular :size="50" color="green" indeterminate></v-progress-circular>
      </v-overlay>
      <!-- Textfield para la barra de Búsqueda -->
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        class="ml-auto"
        label="Búsqueda"
        hide-details
        single-line
        style="max-width: 250px"
      />
      <!-- Termina extfield para la barra de Búsqueda -->

      <!-- Empieza dialogo cancelar -->
      <ConfirmationDialog v-model="isSure" @click="cancel" />
      <!-- Termina dialogo cancelarº -->

      <!-- Empieza Dialogo nuevo usuario persistent -->
      <v-dialog v-model="dialog" max-width="500" max-height="450" persistent>
        <v-card inline title="Usuarios" class="px-2 py-2">
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>
          <v-form v-model="valid">
            <!-- <v-container> -->
            <v-col>
              <!-- login -->
              <v-row cols="6" md="4">
                <v-col>
                  <v-text-field
                    v-model="$v.editedItem.usr_login.$model"
                    dense
                    maxlength="100"
                    label="Login"
                    required
                    :disabled="isEditing"
                    :error-messages="LoginErrors"
                    @input="$v.editedItem.usr_login.$reset(), (changed = true)"
                    @blur="$v.editedItem.usr_login.$touch()"
                  ></v-text-field>
                </v-col>
              </v-row>
              <!-- Nombre(s) del Usuario -->
              <v-row cols="6" md="4">
                <v-col>
                  <v-text-field
                    v-model="$v.editedItem.usr_nombre.$model"
                    dense
                    maxlength="255"
                    required
                    label="Nombre Completo*"
                    :error-messages="usr_nombreErrors"
                    @input="$v.editedItem.usr_nombre.$reset(), (changed = true)"
                    @blur="$v.editedItem.usr_nombre.$touch()"
                  ></v-text-field>
                </v-col>
              </v-row>
              <!-- campo ENTIDAD -->
              <v-row cols="6" md="4">
                <v-col>
                  <v-select
                    v-model="$v.editedItem.id_entidad.$model"
                    :items="entidades"
                    :menu-props="{ top: true, offsetY: true }"
                    label="Entidades*"
                    item-text="ent_nombre"
                    item-value="id_entidad"
                    persistent-hint
                    dense
                    hint="Seleciona Entidad"
                    return-object
                    :error-messages="id_entidadErrors"
                    @input="changed = true"
                    @blur="$v.editedItem.id_entidad.$touch()"
                  >
                  </v-select>
                </v-col>
              </v-row>
              <!-- campo ROL -->
              <v-row cols="6" md="4">
                <v-col>
                  <v-select
                    v-model="$v.editedItem.usr_rol.$model"
                    :items="roles"
                    :menu-props="{ top: true, offsetY: true }"
                    label="Rol de Usuario*"
                    item-text="usr_rol_name"
                    item-value="usr_rol"
                    persistent-hint
                    dense
                    hint="Seleciona Rol"
                    return-object
                    :error-messages="rol_Errors"
                    @input="changed = true"
                    @blur="$v.editedItem.usr_rol.$touch()"
                  >
                  </v-select>
                </v-col>
              </v-row>
              <!-- Correo del Usuario -->
              <v-row cols="6" md="4">
                <v-col>
                  <v-text-field
                    v-model="$v.editedItem.usr_correo.$model"
                    dense
                    label="Correo Electrónico*"
                    :error-messages="emailErrors"
                    @input="$v.editedItem.usr_correo.$reset(), (changed = true)"
                    @blur="$v.editedItem.usr_correo.$touch()"
                  ></v-text-field>
                </v-col>
              </v-row>
              <!-- telefono del Usuario -->
              <v-row cols="6" md="4">
                <v-col>
                  <v-text-field
                    v-model="editedItem.usr_telefono"
                    dense
                    label="Teléfono"
                    @input="$v.editedItem.usr_telefono.$reset(), (changed = true)"
                    @blur="$v.editedItem.usr_telefono.$touch()"
                  ></v-text-field>
                </v-col>
              </v-row>
              <!-- <v-row cols="6" md="4">
                <v-checkbox label="Establecer contraseña" v-model="isPassword" />
              </v-row> -->
              <!-- Contraseña del usuario -->
              <v-row cols="6" md="4">
                <v-col>
                  <v-text-field
                    v-model="$v.editedItem.usr_pwd.$model"
                    dense
                    label="Contraseña"
                    :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show ? 'text' : 'password'"
                    :counter="15"
                    :error-messages="passwordErrors"
                    @click:append.prevent="show = !show"
                    @input="$v.editedItem.usr_pwd.$reset(), (changed = true)"
                    @blur="$v.editedItem.usr_pwd.$touch()"
                  ></v-text-field>
                </v-col>
                <!-- Confirmación de contraseña del usuario -->
                <v-col>
                  <v-text-field
                    v-model="$v.editedItem.repassword.$model"
                    dense
                    label="Confirmar Contraseña"
                    :append-icon="reShow ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="reShow ? 'text' : 'password'"
                    :counter="15"
                    :error-messages="rePasswordErrors"
                    @click:append.prevent="reShow = !reShow"
                    @input="$v.editedItem.repassword.$reset(), (changed = true)"
                    @blur="$v.editedItem.repassword.$touch()"
                  ></v-text-field>
                </v-col>
                <!-- Campo ACTIVO -->
                <v-col cols="12">
                  <v-checkbox
                    v-model="editedItem.usr_activo"
                    :label="`Estatus: ${
                      editedItem.usr_activo.toString() == 'true' ? 'Activo' : 'Inactivo'
                    }`"
                    @input="$v.editedItem.usr_activo.$reset(), (changed = true)"
                    @blur="$v.editedItem.usr_activo.$touch()"
                  >
                  </v-checkbox>
                </v-col>
              </v-row>
            </v-col>
            <div class="body-2 font-weight-thin">*Campo Obligatorio</div>
            <!-- </v-container> -->
          </v-form>
          <!-- Botones y checkList -->
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-checkbox v-model="checkbox" label="Crear otro"></v-checkbox>
            <v-btn color="red darken-1" text @click="checkChanges">Cancelar</v-btn>
            <v-btn color="blue darken-1" text @click="saveForm" :disabled="$v.$invalid"
              >Guardar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Termina Dialogo nuevo usuario-->

      <!-- Empieza Dialogo2 invitar usuario persistent -->
      <v-dialog v-model="dialog2" max-width="500" max-height="450" persistent>
        <v-card inline title="Usuarios" class="px-2 py-2">
          <v-card-title>
            <span class="headline">Invitar Usuario</span>
          </v-card-title>
          <v-form v-model="valid">
            <!-- <v-container> -->
            <!-- Correo electrónico del usuario a invitar -->
            <v-col>
              <v-row cols="6" md="4">
                <v-col>
                  <v-text-field
                    v-model="$v.editedItem.usr_correo.$model"
                    dense
                    label="Correo Electrónico*"
                    required
                    :error-messages="emailErrors"
                    @input="$v.editedItem.usr_correo.$reset()"
                    @blur="$v.editedItem.usr_correo.$touch()"
                  ></v-text-field>
                </v-col>
              </v-row>
              <!-- <v-row cols="6" md="4">
                <v-checkbox label="Establecer contraseña" v-model="isPassword" />
              </v-row>-->
            </v-col>
            <div class="body-2 font-weight-thin">*Campo Obligatorio</div>
            <!-- </v-container> -->
          </v-form>
          <!-- Botones -->
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="sendEmail"
              :disabled="$v.editedItem.usr_correo.$invalid"
              >Aceptar</v-btn
            >
            <v-btn color="red darken-1" text @click="closeForm">Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Termina Dialogo2 invitar usuario -->

      <v-divider class="mt-3" />
      <v-data-table
        :headers="headers"
        :items="usuarios"
        :search.sync="search"
        :sort-by="['nombre']"
        :sort-desc="[false]"
        :loading="isLoading"
        loading-text="Cargando... Espere por favor"
        multi-sort
      >
        <template v-slot:item.usr_activo="{ item }">
          <Status :activostr="item.usr_activo" tipo="String" />
        </template>
        <template v-slot:[`item.login`]="{ item }">
          <SessionInfo :loginTimes="item.login_times" :lastLogin="item.last_login" />
        </template>
        <!-- <template #item.login_times="{item}"> <b>Conexiones:</b> {{ item.login_times }} </template> -->
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon small class="mr-5" @click="editItem(item)">mdi-pencil</v-icon>
          <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { getValidToken } from '@/store/helpers.js'
import { required, minLength, maxLength, email, sameAs } from 'vuelidate/lib/validators'
import SessionInfo from '@/components/general/SessionInfo.vue'
import ConfirmationDialog from '@/components/general/ConfirmationDialog.vue'
import Status from '@/components/general/StatusInfo.vue'

const checkPassword = (value) => {
  if (!value) {
    return true
  }
  if (String(value).length < 6 || String(value).length > 16) {
    return false
  }
  return true
}

const oneNumber = (value) => {
  if (value != '') {
    return /[0-9]/.test(value)
  } else {
    return true
  }
}

const oneUpperCase = (value) => {
  if (value != '') {
    return /[A-Z]/.test(value)
  } else {
    return true
  }
}

const oneLowerCase = (value) => {
  if (value != '') {
    return /[a-z]/.test(value)
  } else {
    return true
  }
}

// const noWhitespace = (value) => value.indexOf(' ') === -1

export default {
  name: 'DashboardDataTables',

  components: {
    SessionInfo,
    ConfirmationDialog,
    Status,
  },
  data: () => ({
    search: undefined,
    valid: false,
    isLoading: false,
    isEditing: false,
    checkbox: false,
    dialog: false,
    dialog2: false,
    isSure: false,
    show: false,
    reShow: false,
    isPassword: false,
    overlay: false,
    changed: false,
    headers: [
      { text: 'ID', value: 'id_usr' },
      { text: 'Usuario', align: 'start', sortable: false, value: 'usr_login' },
      { text: 'Nombre', value: 'usr_nombre' },
      //{ text: 'Correo Electrónico', value: 'usr_correo' },
      { text: 'Entidad', value: 'ent_nombre' },
      { text: 'Activo', value: 'usr_activo' },
      { text: 'Datos de inicio de sesión', value: 'login' },
      { text: 'Acciones', value: 'actions', sortable: false },
    ],
    roles: [
      { usr_rol: 'admin', usr_rol_name: 'Administrador' },
      { usr_rol: 'captura', usr_rol_name: 'Captura' },
      { usr_rol: 'revision', usr_rol_name: 'Revision' },
    ],
    usuarios: [],
    entidades: [],
    editedIndex: -1,
    editedItem: {
      id_usr: '',
      usr_nombre: '',
      usr_correo: '',
      usr_pwd: '',
      usr_login: '',
      repassword: '',
      id_entidad: 0,
      usr_telefono: '',
      usr_rol: '',
      usr_activo: true,
    },
    defaultItem: {
      id_usr: '',
      usr_nombre: '',
      usr_correo: '',
      usr_pwd: '',
      usr_login: '',
      repassword: '',
      id_entidad: 0,
      usr_telefono: '',
      usr_rol: '',
      usr_activo: true,
    },
  }),
  mixins: [validationMixin],
  validations: {
    editedItem: {
      usr_nombre: { required, minLength: minLength(3), maxLength: maxLength(255) },
      usr_login: { required, minLength: minLength(3), maxLength: maxLength(100) },
      id_entidad: { required },
      usr_rol: { required },
      usr_correo: { email },
      usr_pwd: {
        checkPassword,
        oneNumber,
        oneUpperCase,
        oneLowerCase,
      },
      repassword: {
        sameAsPassword: sameAs('usr_pwd'),
      },
    },
  },
  watch: {
    dialog(val) {
      val || this.closeForm()
    },
    dialog2(val) {
      val || this.closeForm()
    },
  },

  created() {
    this.iniciando()
  },
  methods: {
    //Refresca Datos para la tabla
    async iniciando() {
      let jwt = await getValidToken(this)
      this.obtenerUsuarios(jwt)
      this.obtenerEntidades(jwt)
    },
    //Obtiene todos las ENTIDADES para el select
    async obtenerEntidades(jwt) {
      //async obtenerEntidades(jwt) {
      //console.log('obtenerEntidades ' + isAdmin + idEntidad)
      this.isLoading = true
      let params = null
      //let jwt = await getValidToken(this)
      if (jwt != null) {
        let payload = { jwt: jwt, params: params }
        this.$store
          .dispatch('entidad/fetchEntidad', payload)
          .then((response) => {
            this.entidades = response.data
            this.isLoading = false
          })
          .catch((err) => {
            this.isLoading = false
            this.$store.commit('ALERT', {
              color: 'error',
              text: err.response.data.error,
              // Enviar a inicio de sesión
            })
          })
      }
    },
    // Obtiene todos los registros
    async obtenerUsuarios(jwt) {
      this.isLoading = true
      //let jwt = await getValidToken(this)
      //console.log(jwt)
      if (jwt !== null) {
        let payload = { jwt: jwt }
        this.$store
          .dispatch('user/fetchUsers', payload)
          .then((response) => {
            this.usuarios = response.data
            this.isLoading = false
          })
          .catch((error) => {
            console.log(error)
          })
      }
    },
    // Editar registro
    editItem(item) {
      this.isEditing = true
      this.editedIndex = this.usuarios.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.editedItem.usr_pwd = ''
      this.editedItem.repassword = ''
      this.editedItem.usr_activo = this.editedItem.usr_activo == 1 ? true : false
      
      this.dialog = true
    },
    // Eliminar registro
    deleteItem(item) {
      const index = this.usuarios.indexOf(item)
      confirm('Esta seguro que desea eliminar este registro?') && this.usuarios.splice(index, 1)
      this.Borrar(item.id_usr)
    },
    //Borrar en BD es desActivar
    async Borrar(index) {
      this.overlay = true
      this.$v.$touch()

      let body = {
        //_id: this.editedItem.id_tipo,
        id_usr: index,
        //tipo_nombre: this.editedItem.tipo_nombre,
        usr_activo: 0,
      }
      let jwt = await getValidToken(this)
      let payload = { jwt: jwt, body: body }
      payload.id = index
      this.$store
        .dispatch('user/deleteUser', payload)
        .then(() => {
          this.$store.commit('ALERT', {
            color: 'success',
            text: 'El registro se eliminó con éxito',
          })
          this.overlay = false
        })
        .catch((err) => {
          this.$store.commit('ALERT', {
            color: 'error',
            text: err.response.data.msg,
            // Enviar a inicio de sesión
          })
          this.overlay = false
        })
      Object.assign(this.entidades[this.editedIndex], this.editedItem)
    },
    // Guardar contenido del formulario
    async saveForm() {
      this.overlay = true
      this.$v.$touch()
      if (!this.$v.$invalid) {
        let entidad = 0
        if (this.editedItem.id_entidad.id_entidad == null) {
          entidad = this.editedItem.id_entidad
        } else {
          entidad = this.editedItem.id_entidad.id_entidad
        }
                let rol = 0
        if (this.editedItem.usr_rol.usr_rol == null) {
          rol = this.editedItem.usr_rol
        } else {
          rol = this.editedItem.usr_rol.usr_rol
        }

        let body = {
          usr_login: this.editedItem.usr_login,
          usr_nombre: this.editedItem.usr_nombre,
          usr_correo: this.editedItem.usr_correo,
          id_entidad: entidad,
          usr_telefono: this.editedItem.usr_telefono,
          usr_activo: this.editedItem.usr_activo == true ? 1 : 0,
          usr_rol: rol,
        }
        if (this.editedItem.usr_pwd !== '') {
          //body.login = { usr_pwd: this.editedItem.usr_pwd }
          body.usr_pwd = this.editedItem.usr_pwd
        }
        let jwt = await getValidToken(this)

        if (this.editedIndex > -1) {
          // Edicion del registro
          let id = this.editedItem.id_usr
          let payload = { jwt: jwt, id: id, body: body }
          this.$store
            .dispatch('user/editUser', payload)
            .then(() => {
              this.$store.commit('ALERT', {
                color: 'success',
                text: 'El registro fue actualizado con éxito',
              })
              this.overlay = false
            })
            .catch((err) => {
              this.$store.commit('ALERT', {
                color: 'error',
                text: err.response.data.msg,
              })
              this.overlay = false
            })
          Object.assign(this.usuarios[this.editedIndex], this.editedItem)
        } else {
          // Registro nuevo
          // body.login = { password: this.editedItem.password }
          let payload = { jwt: jwt, body: body }
          await this.$store
            .dispatch('user/addUser', payload)
            .then((response) => {
              this.$store.commit('ALERT', {
                color: 'success',
                text: 'El registro se creo con éxito',
              })
              // Aqui va el response.data
              // this.usuarios.push(this.editedItem)
              this.usuarios.push(response.data)
              this.overlay = false
            })
            .catch((err) => {
              this.$store.commit('ALERT', {
                color: 'error',
                text: err.response.data.errores,
              })
              this.overlay = false
            })
        }
        this.closeForm()
      }
    },
    // Invitar Nuevo Usuario (enviar email)
    async sendEmail() {
      this.overlay = true
      this.$v.$touch()
      if (!this.$v.editedItem.usr_correo.$invalid) {
        let body = {
          usr_correo: this.editedItem.usr_correo,
        }
        let jwt = await getValidToken(this)
        let payload = { jwt: jwt, body: body }
        this.$store
          .dispatch('user/inviteUser', payload)
          .then(() => {
            this.$store.commit('ALERT', {
              color: 'success',
              text: 'Se ha enviado la invitación con éxito',
            })
            this.overlay = false
          })
          .catch((err) => {
            this.$store.commit('ALERT', {
              color: 'error',
              text: err.response.data.msg,
            })
            this.overlay = false
          })
        this.closeForm()
      }
    },
    // Cerrar formulario
    closeForm(checkbox) {
      this.isSure = false
      this.checkbox = checkbox
      if (!this.checkbox) {
        this.dialog = false
        this.isEditing = false
      }
      this.dialog2 = false
      this.show = false
      this.reShow = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
        this.clearForm()
      })
      this.$v.$reset()
    },
    // Limpiar formulario
    clearForm() {
      this.$v.$reset()
      ;(this.editedItem.id_usr = 0),
        (this.editedItem.usr_login = ''),
        (this.editedItem.usr_nombre = ''),
        (this.editedItem.usr_activo = true),
        (this.editedItem.usr_rol = ''),
        (this.editedItem.usr_correo = ''),
        (this.editedItem.usr_pwd = ''),
        (this.editedItem.repassword = '')
    },
    // Revisar si hay cambios en el formulario
    checkChanges() {
      if (this.changed) {
        this.isSure = true
      } else {
        this.closeForm(false)
        this.changed = false
      }
    },
    // Confirmar la cancelación
    cancel(isSure) {
      this.isSure = isSure
      if (this.isSure) {
        this.closeForm(false)
        this.changed = false
      }
    },
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'Nuevo Usuario' : 'Editar Usuario'
    },
    usr_nombreErrors() {
      const errors = []
      if (!this.$v.editedItem.usr_nombre.$dirty) return errors
      !this.$v.editedItem.usr_nombre.required && errors.push('Este campo es requerido')
      !this.$v.editedItem.usr_nombre.minLength &&
        errors.push('Este campo debe de tener un mínimo de 3 caracteres.')
      !this.$v.editedItem.usr_nombre.maxLength &&
        errors.push('Este campo debe de tener un máximo de 20 caracteres.')
      return errors
    },
    LoginErrors() {
      const errors = []
      if (!this.$v.editedItem.usr_login.$dirty) return errors
      !this.$v.editedItem.usr_login.required && errors.push('Este campo es requerido')
      !this.$v.editedItem.usr_login.minLength &&
        errors.push('Este campo debe de tener un mínimo de 3 caracteres.')
      !this.$v.editedItem.usr_login.maxLength &&
        errors.push('Este campo debe de tener un máximo de 100 caracteres.')
      return errors
    },
    id_entidadErrors() {
      const errors = []
      if (!this.$v.editedItem.id_entidad.$dirty) return errors
      !this.$v.editedItem.id_entidad.required && errors.push('Este campo es requerido')
      return errors
    },
    rol_Errors() {
      const errors = []
      if (!this.$v.editedItem.id_entidad.$dirty) return errors
      !this.$v.editedItem.id_entidad.required && errors.push('Este campo es requerido')
      return errors
    },

    emailErrors() {
      const errors = []
      if (!this.$v.editedItem.usr_correo.$dirty) return errors
      !this.$v.editedItem.usr_correo.email && errors.push('Debe ser un correo electrónico válido')
      return errors
    },
    passwordErrors() {
      const errors = []
      if (!this.$v.editedItem.usr_pwd.$dirty) return errors
      !this.$v.editedItem.usr_pwd.checkPassword &&
        errors.push('La contraseña debe de tener un mínimo de 6 caracteres y un máximo de 15.')
      !this.$v.editedItem.usr_pwd.oneNumber &&
        errors.push('La contraseña debe de tener al menos un número')
      !this.$v.editedItem.usr_pwd.oneUpperCase &&
        errors.push('La contraseña debe de tener al menos una letra mayúscula')
      !this.$v.editedItem.usr_pwd.oneLowerCase &&
        errors.push('La contraseña debe de tener al menos una letra minúscula')
      return errors
    },
    rePasswordErrors() {
      const errors = []
      if (!this.$v.editedItem.repassword.$dirty) return errors
      !this.$v.editedItem.repassword.sameAsPassword && errors.push('La contraseña debe ser igual.')
      return errors
    },
  },
}
</script>
